import { useEffect } from 'react';
import { loadModel, refKey, useWorkspace, type LoadedModel, type ModelRef } from './workspace';

/** The model for a reference, loading it when needed (and again after a live change clears it). */
export function useModel(ref: ModelRef | null): { model: LoadedModel | undefined; error: string | undefined; loading: boolean } {
  const key = ref ? refKey(ref) : null;
  const model = useWorkspace((s) => (key ? s.models[key] : undefined));
  const error = useWorkspace((s) => (key ? s.modelErrors[key] : undefined));
  const ready = useWorkspace((s) => s.discovery !== null);
  useEffect(() => {
    if (ref && ready && !model && !error) void loadModel(ref);
    // `key` identifies `ref`, so `ref` itself is deliberately not a dependency.
  }, [key, ready, model, error]);
  return { model, error, loading: !!ref && !model && !error };
}
